import * as Yup from "yup";
import { XGSSelectOption } from "../../../ui-components/xgs-select/xgsSelect";

export interface ImageHistoryLogsResponseModel {
    eventId: string;        // Status of the event (e.g., "success")
    eventTime: string;   // Indicates if the program halted (e.g., "N")
    imgStatus: string;     // Type of the event
    isPgmHalt: string;  // Description of the event
    event: string;     // Type of the event
    eventSource: string;   // Source of the event
    eventDetails: string;  // Description of the event
    associatedUser: string;
    associatedEmail: string;
}

export interface ImageHistoryLogsResponseItemModel {
    docId: string;       // Unique event ID
    docType: string;     // Timestamp of the event
    docStatus: string;        // Status of the event (e.g., "success")
    probill: string;   // Indicates if the program halted (e.g., "N")
    customerNumber: string;     // Type of the event
    customerName: string;   // Source of the event
    bol: string;  // Description of the event
    po: string;       // Unique event ID
    terminal: string;     // Timestamp of the event
    terminalName: string;
    image: string;
    failedeventsCount: string;
    events: ImageHistoryLogsResponseModel[];  // Array of event logs
}
export interface ImageHistoryLogsItemModel {
    page: number;                      // Current page number
    pageSize: number;                  // Number of records per page
    totalRecords: number;              // Total number of records available
    totalPages: number;                // Total number of pages
    data: ImageHistoryLogsResponseItemModel[];  // Array of event logs
}

export interface ImageHistoryTableInfoModel {
    title: string,
    description: string,
    sections: []
}
export interface ImageHistoryLogsFilterModel {
    terminal?: XGSSelectOption | null | undefined;
    docId?: string | undefined;
    trackNumber?: string | undefined;
    customer?: string | undefined;
    eventTimeFrom: string | undefined | null,
    eventTimeTo: string | undefined | null,
    docStatus: XGSSelectOption | null | undefined,
    docType: XGSSelectOption | null | undefined;
    user?: string | undefined;
};

export const ImageHistoryLogsFilterSchema: Yup.ObjectSchema<ImageHistoryLogsFilterModel> = Yup.object()
    .shape({
        docId: Yup.string()
            .matches(/^\d+$/, "Only whole numbers are allowed.")
            .min(7, "Document ID must be greater than 100000 or empty."),
        eventTimeFrom: Yup.string()
            .nullable()
            .test("is-valid-from", "Start and end dates must both be provided or left empty.", function (value) {
                const { eventTimeFrom, eventTimeTo } = this.parent;
                return (!eventTimeFrom && !eventTimeTo) || (eventTimeFrom && eventTimeTo);
            }),
        eventTimeTo: Yup.string()
            .nullable()
            .test("is-valid-to", "Start and end dates must both be provided or left empty.", function (value) {
                const { eventTimeFrom, eventTimeTo } = this.parent;
                return (!eventTimeFrom && !eventTimeTo) || (eventTimeFrom && eventTimeTo);
            }),
        customer: Yup.string(),
        trackNumber: Yup.string(),
        terminal: Yup.object<XGSSelectOption>().optional().nullable()
            .test("terminal-value", "Status must have a valid value", function (value) {
                return value === null || value === undefined || (value.value !== undefined && value.value !== "");
            }),

        docStatus: Yup.object<XGSSelectOption>().optional().nullable()
            .test("docStatus-value", "Event type must have a valid value", function (value) {
                return value === null || value === undefined || (value.value !== undefined && value.value !== "");
            }),

        docType: Yup.object<XGSSelectOption>().optional().nullable()
            .test("docType-value", "Event source must have a valid value", function (value) {
                return value === null || value === undefined || (value.value !== undefined && value.value !== "");
            }),
        user: Yup.string()
            .test("is-valid-user", "Email or Capital Username", function (value) {
                if (!value) return true; // allow empty

                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (emailRegex.test(value)) return true;

                // Split words and check for all uppercase & one word ≥ 4 chars
                const words = value.trim().split(/\s+/);
                const allUppercase = words.every((word: string) => /^[A-Z]+$/.test(word));
                const hasMinLengthWord = words.some((word: string | any[]) => word.length >= 4);

                return allUppercase && hasMinLengthWord;
            })
    }).defined()

